import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

export function useDeepLinks() {
  const navigate = useNavigate();

  useEffect(() => {
    // Gestisce i deep link solo su piattaforme native (iOS/Android)
    if (!Capacitor.isNativePlatform()) {
      return; // Su web, i link funzionano già normalmente
    }

    // Importa dinamicamente @capacitor/app solo su mobile
    import('@capacitor/app').then(({ App: CapacitorApp }) => {
      // Gestisce i deep link quando l'app viene aperta da un link esterno
      const handleAppUrlOpen = CapacitorApp.addListener('appUrlOpen', (event) => {
        console.log('📲 Deep link ricevuto:', event.url);
        
        try {
          // Estrae il path dal link
          // Supporta sia wishare://shared/ABC123 che https://wishareapp.com/shared/ABC123
          const url = new URL(event.url);
          let path = url.pathname;
          
          // Per custom URL scheme (wishare://), il "host" contiene il path
          if (url.protocol === 'wishare:') {
            path = '/' + url.host + url.pathname;
          }
          
          console.log('🔀 Navigazione verso:', path);
          
          // Naviga al path corretto nell'app
          if (path && path !== '/') {
            navigate(path, { replace: true });
          }
        } catch (error) {
          console.error('Errore nel parsing del deep link:', error);
        }
      });

      // Pulisce il listener quando il componente viene smontato
      return () => {
        handleAppUrlOpen.then(listener => listener.remove());
      };
    });
  }, [navigate]);
}
